"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLIS_PROPERTY_CONTEXT = void 0;

var rtlcss = require("rtlcss"); // https://github.com/thysultan/stylis.js#plugins


var STYLIS_CONTEXTS = {
  POST_PROCESS: -2,
  PREPARATION: -1,
  NEWLINE: 0,
  PROPERTY: 1,
  SELECTOR_BLOCK: 2,
  AT_RULE: 3
};
exports.STYLIS_PROPERTY_CONTEXT = STYLIS_CONTEXTS.PREPARATION;

function stylisRTLCSS(context, content) {
  if (context === exports.STYLIS_PROPERTY_CONTEXT) {
    return rtlcss.process(content);
  }
} // stable identifier that will not be dropped by minification unless the whole module
// is unused

/*#__PURE__*/


Object.defineProperty(stylisRTLCSS, "name", {
  value: "stylisRTLCSS"
});
exports.default = stylisRTLCSS;